var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcTier1 = function SvgIcTier1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 208,
    viewBox: "0 0 208 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ic-tier-1_svg__filter0_d_1871_5846)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.585,
    y: 3.39624,
    width: 180,
    height: 180,
    rx: 33.9623,
    fill: "url(#ic-tier-1_svg__paint0_linear_1871_5846)",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic-tier-1_svg__clip0_1871_5846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.5305 75.4335C93.3667 74.9568 100.897 64.5311 100.352 52.1455C99.8063 39.7599 91.3911 30.1064 81.5562 30.5831C71.72 31.0598 64.1897 41.4867 64.7338 53.871C65.2792 66.2567 73.6943 75.9102 83.5292 75.4335H83.5305Z",
    fill: "#00BFA2",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8353 82.6336C61.8817 72.2209 52.7826 65.8746 44.5139 68.4577C36.2452 71.0421 31.9366 81.5765 34.8915 91.9892C37.845 102.402 46.9428 108.748 55.2129 106.165C63.4816 103.582 67.7902 93.0475 64.8353 82.6349V82.6336Z",
    fill: "#00BFA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.642 75.4335C134.477 75.9102 142.892 66.2567 143.438 53.871C143.983 41.4867 136.451 31.0598 126.615 30.5831C116.78 30.1064 108.365 39.7599 107.82 52.1455C107.274 64.5311 114.806 74.9568 124.641 75.4335H124.642Z",
    fill: "#00BFA2",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.657 68.4587C155.388 65.8756 146.291 72.2219 143.336 82.6346C140.381 93.0472 144.69 103.582 152.958 106.165C161.227 108.748 170.325 102.402 173.28 91.9889C176.235 81.5762 171.926 71.0417 163.657 68.4587Z",
    fill: "#00BFA2",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.474 108.87C134.099 104.164 131.103 99.7219 128.044 95.9108C122.539 89.0489 113.997 84.7908 104.085 84.7908C94.1741 84.7908 85.632 89.0489 80.1264 95.9108C77.0679 99.7219 74.0716 104.164 66.6967 108.87C60.4268 112.872 55.8578 118.975 54.2256 125.844H153.945C152.313 118.975 147.744 112.871 141.474 108.87Z",
    fill: "#00BFA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2258 125.845C53.3332 129.601 53.3177 133.586 54.3838 137.581C57.9864 151.079 72.1636 158.939 86.048 155.135C87.771 154.662 89.3333 153.923 90.8658 153.171C95.8389 150.735 100.737 151.04 104.084 151.04C107.432 151.04 112.33 150.735 117.303 153.171C118.835 153.923 120.398 154.662 122.121 155.135C136.006 158.94 150.182 151.08 153.786 137.581C154.852 133.586 154.837 129.601 153.944 125.845H54.2258Z",
    fill: "#00BFA2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ic-tier-1_svg__filter0_d_1871_5846",
    x: 0.0000553131,
    y: 0.0000133514,
    width: 207.17,
    height: 207.17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.1887
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.79245
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1871_5846"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1871_5846",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-tier-1_svg__paint0_linear_1871_5846",
    x1: 103.585,
    y1: 3.39624,
    x2: 103.585,
    y2: 183.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ic-tier-1_svg__clip0_1871_5846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140.251,
    height: 125.526,
    fill: "white",
    transform: "translate(33.96 30.5662)"
  })))));
};
export default SvgIcTier1;